import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-user-activity',
  templateUrl: './view-user-activity.component.html',
  styleUrls: ['./view-user-activity.component.css']
})
export class ViewUserActivityComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
